import axios from 'axios';
import { useEffect, useState } from 'react';
import { api_bd_nr } from '../../services/Api.js';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid } from 'recharts';
import HermesStats from '../HermesStats/index.js';

const COLORS = { dentro: '#22c55e', fora: '#ef4444' };

function TreatmentsReport(props) {
	const [treatmentsData, setTreatmentstData] = useState([])

	const formatToExport = (_data) => {
		//Lines
		let xlsx = [
			['Cliente:', _data.customer_name], //line 1
			['Tempo Total:', _data.tempoTotalF], //line 2
			[],//line 3
			['Ticket', 'Título', 'Tempo', 'Analistas'], //line 4
		]

		let temp = Object.keys(_data.analistas).map(key => {
			return ({
				..._data.analistas[key]
			})
		})

		temp = temp.sort((a, b) => {
			if (a.analista < b.analista) {
				return -1;
			}
			if (a.analista > b.analista) {
				return 1;
			}
			return 0;
		})

		temp.forEach(el => {
			Object.keys(el.ticketsPerDate).length > 0 && Object.keys(el.ticketsPerDate).map((key) => {
				Object.keys(el.ticketsPerDate[key]).map((key2) => {
					xlsx.push([
						key2,
						el.ticketsPerDate[key][key2].titulo,
						el.ticketsPerDate[key][key2].tempoF,
						el.ticketsPerDate[key][key2].respTec.join(', ')
					])
				})
			})
		})

		// console.log('result', xlsx)
		exportToCsv(xlsx, `Report ${_data.customer_name}`)
	}

	// var Results = [array1, array2];
	const exportToCsv = function (_arrOfArr, title) {
		let CsvString = "";
		_arrOfArr.forEach(function (RowItem, RowIndex) {
			RowItem.forEach(function (ColItem, ColIndex) {
				CsvString += ColItem + ",";
			});
			CsvString += "\r\n";
		});
		CsvString = "data:application/csv," + encodeURIComponent(CsvString);
		let x = document.createElement("A");
		x.setAttribute("href", CsvString);
		x.setAttribute("download", `${title}.csv`);
		document.body.appendChild(x);
		x.click();
	};

	const loadTreatmentsData = () => {
		api_bd_nr.get(`/analystreports/treatments/${props.interval.datei.toLocaleDateString('en-ca')}/${props.interval.datef.toLocaleDateString('en-ca')}`)
			.then(resp => {
				// console.log('treatmentsData', resp.data)
				setTreatmentstData(resp.data)
			})
	}

	useEffect(() => {
		loadTreatmentsData()

		let intervalLoad = setInterval(() => {
			loadTreatmentsData()
		}, 600000)

		return () => {
			clearInterval(intervalLoad)
		}

		// }
	}, [props.interval])

	const dentro = treatmentsData.filter(t => t.dentroDoLimite === true).length
	const fora = treatmentsData.filter(t => t.dentroDoLimite === false).length
	const total = dentro + fora

	const limitData = [
		{ name: 'Dentro do limite', value: dentro, color: COLORS.dentro },
		{ name: 'Fora do limite', value: fora, color: COLORS.fora },
	]

	// Agrupado por analista da interação
	const byAnalyst = Object.values(
		treatmentsData.reduce((acc, t) => {
			if (t.dentroDoLimite === null || !t.interacaoAnalistaNome) return acc
			const nome = t.interacaoAnalistaNome
			if (!acc[nome]) acc[nome] = { analista: nome, dentro: 0, fora: 0 }
			t.dentroDoLimite ? acc[nome].dentro++ : acc[nome].fora++
			return acc
		}, {})
	).map(a => {
		const tot = a.dentro + a.fora
		return {
			...a,
			total: tot,
			pctDentro: +(a.dentro / tot * 100).toFixed(1),
			pctFora: +(a.fora / tot * 100).toFixed(1),
		}
	}).sort((a, b) => b.pctDentro - a.pctDentro)

	// Agrupado por analista -> ticketId -> tratativas
	const groupedByAnalyst = Object.values(
		treatmentsData.reduce((acc, t) => {
			const nome = t.interacaoAnalistaNome || t.analistaNome || 'Sem analista'
			if (!acc[nome]) acc[nome] = { analista: nome, tickets: {} }
			if (!acc[nome].tickets[t.ticketId]) {
				acc[nome].tickets[t.ticketId] = { ticketId: t.ticketId, titulo: t.titulo, customerName: t.customerName, tratativas: [] }
			}
			acc[nome].tickets[t.ticketId].tratativas.push(t)
			return acc
		}, {})
	).map(a => ({
		...a,
		tickets: Object.values(a.tickets).sort((x, y) => x.ticketId - y.ticketId),
	})).sort((a, b) => a.analista.localeCompare(b.analista))

	return (
		<div className='w-full h-full'>
			<div className='w-full max-w-xl mx-auto flex flex row gap-8 justify-center items-start'>
				<div className="min-w-[420px] rounded border p-4 bg-white">
					<HermesStats />
				</div>

				<div className="min-w-[420px] rounded border p-4 bg-white">
					<h2 className='text-lg font-semibold text-center mb-2'>Tratativas e interações</h2>
					<h4 className='text-sm font-semibold text-center mb-2'>Base de cálculo (30min)</h4>
					{total > 0 ? (
						<ResponsiveContainer width='100%' height={420}>
							<PieChart margin={{ top: 10, right: 20, bottom: 10, left: 20 }}>
								<Pie
									data={limitData}
									dataKey='value'
									nameKey='name'
									cx='50%'
									cy='50%'
									outerRadius={140}
									labelLine={false}
									label={({ percent }) => `${(percent * 100).toFixed(1)}%`}
								>
									{limitData.map((entry) => (
										<Cell key={entry.name} fill={entry.color} />
									))}
								</Pie>
								<Tooltip formatter={(value) => [`${value} tratativa(s)`, '']} />
								<Legend />
							</PieChart>
						</ResponsiveContainer>
					) : (
						<p className='text-center text-gray-500'>Sem dados.</p>
					)}
				</div>
			</div>

			<div className='w-full max-w-3/4 mx-auto mt-8'>
				<h2 className='text-lg font-semibold text-center mb-2'>Tratativas e interações por analista (%)</h2>
				{byAnalyst.length > 0 ? (
					<ResponsiveContainer width='100%' height={Math.max(300, byAnalyst.length * 50)}>
						<BarChart data={byAnalyst} layout='vertical' margin={{ left: 40 }}>
							<CartesianGrid strokeDasharray='3 3' />
							<XAxis type='number' domain={[0, 100]} unit='%' />
							<YAxis type='category' dataKey='analista' width={120} />
							<Tooltip formatter={(value, name) => [`${value}%`, name]} />
							<Legend />
							<Bar dataKey='pctDentro' name='Dentro do limite' stackId='a' fill={COLORS.dentro} />
							<Bar dataKey='pctFora' name='Fora do limite' stackId='a' fill={COLORS.fora} />
						</BarChart>
					</ResponsiveContainer>
				) : (
					<p className='text-center text-gray-500'>Sem dados.</p>
				)}
			</div>

			<div className='w-full max-w-3/4 mx-auto mt-8'>
				<h2 className='text-lg font-semibold text-center mb-4'>Tratativas por analista</h2>
				{groupedByAnalyst.map(a => (
					<details key={a.analista} className='mb-4 border rounded' >
						<summary className='cursor-pointer select-none text-base font-bold px-3 py-2 bg-gray-50'>
							{a.analista} <span className='font-normal text-gray-500'>({a.tickets.length} ticket(s))</span>
						</summary>
						<div className='p-3'>
							{a.tickets.map(tk => (
								<details key={tk.ticketId} className='ml-2 mb-2 border-l pl-3'>
									<summary className='cursor-pointer select-none font-semibold text-sm'>
										#{tk.ticketId} — {tk.titulo} <span className='font-normal text-gray-500'>({tk.customerName})</span>
									</summary>
									<ul className='ml-4 mt-1 list-none text-sm flex flex-col gap-2'>
										{tk.tratativas.map((t, i) => {
											const fmtData = (d) => new Date(d).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
											return (
												<li key={i} className='flex items-center gap-3 border rounded px-3 py-2'>
													<span
														title={
															t.dentroDoLimite === true ? 'Dentro do limite'
																: t.dentroDoLimite === false ? 'Fora do limite'
																	: 'Não avaliado'
														}
														className={`shrink-0 inline-block w-2.5 h-2.5 rounded-full ${t.dentroDoLimite === true ? 'bg-green-500'
															: t.dentroDoLimite === false ? 'bg-red-500'
																: 'bg-gray-400'
															}`}
													/>

													{/* Início → Fim da tratativa */}
													<div className='flex items-center gap-2 text-gray-700'>
														<div className='flex flex-col leading-tight'>
															<span className='text-[10px] uppercase text-gray-400'>Início</span>
															<span className='font-medium'>{fmtData(t.tratativaInicio)}</span>
														</div>
														<span className='text-gray-400'>→</span>
														<div className='flex flex-col leading-tight'>
															<span className='text-[10px] uppercase text-gray-400'>Fim</span>
															<span className='font-medium'>{fmtData(t.tratativaFim)}</span>
														</div>
													</div>

													{/* Tempo até próxima interação/tratativa */}
													<div className='ml-auto flex flex-col items-end leading-tight'>
														<span className='text-[10px] uppercase text-gray-400'>
															{t.validadoPor === 'interacao' ? 'Tempo até  interação'
																: t.validadoPor === 'proxima_tratativa' ? 'Tempo até próxima tratativa'
																	: t.validadoPor === 'solucao_ticket' ? 'Tempo até solução'
																		: 'Tempo decorrido'}
														</span>
														<span
															className={`font-semibold ${t.dentroDoLimite === true ? 'text-green-600'
																: t.dentroDoLimite === false ? 'text-red-600'
																	: 'text-gray-500'
																}`}
														>
															{t.tempoFormatado}
														</span>
													</div>
												</li>
											)
										})}
									</ul>
								</details>
							))}
						</div>
					</details>
				))}
			</div>
		</div>
	);
}

export default TreatmentsReport;